export default "__VITE_ASSET__D35L4i27__"